<div class="ws-page ws-page-spacious loc-types-page" [class.loc-types-page--dimmed]="typeModalOpen()">
  <header class="page-head">
    <div>
      <p class="kicker">LARIS · Type configuration</p>
      <div class="page-head-title-row">
        <app-page-back-btn />
        <h2>Manage location types</h2>
        <app-page-refresh-btn [loading]="loading()" (refresh)="reload()" />
      </div>
      <p class="muted ws-lead">
        Define reusable type templates and dynamic field schemas. Hierarchy shape comes from parent-child links — not from fixed levels.
      </p>
    </div>
    <div class="actions">
      <a routerLink="/enforcement/areas" class="btn secondary">
        <lucide-icon name="map-pin" [size]="16" /> Locations
      </a>
      <button type="button" class="btn primary" *ngIf="session.canAccessConfig()" (click)="openCreateType()">
        <lucide-icon name="plus" [size]="16" /> Add type
      </button>
    </div>
  </header>

  <p class="toast" *ngIf="toast()">{{ toast() }}</p>
  <p class="error" *ngIf="error()">{{ error() }}</p>

  <section class="type-stats" aria-label="Type summary">
    <article class="type-stat-card">
      <lucide-icon name="layers" [size]="22" />
      <p class="type-stat-label">Types defined</p>
      <p class="type-stat-value">{{ rows().length }}</p>
    </article>
    <article class="type-stat-card">
      <lucide-icon name="circle-check" [size]="22" />
      <p class="type-stat-label">Active</p>
      <p class="type-stat-value">{{ activeCount() }}</p>
    </article>
    <article class="type-stat-card">
      <lucide-icon name="file-text" [size]="22" />
      <p class="type-stat-label">Total fields</p>
      <p class="type-stat-value">{{ totalFields() }}</p>
    </article>
  </section>

  <section class="page-card page-card--compact-head">
    <div class="bl-toolbar">
      <label class="search-field">
        <lucide-icon name="search" [size]="16" />
        <input [ngModel]="search()" (ngModelChange)="search.set($event)" placeholder="Search types or fields…" />
      </label>
      <span class="bl-count" *ngIf="!loading()">{{ filteredRows().length }} type(s)</span>
    </div>

    <p class="ws-loading" *ngIf="loading()">Loading location types…</p>
    <p class="ws-empty" *ngIf="!loading() && !filteredRows().length">No location types match your search.</p>

    <div class="type-card-grid" *ngIf="!loading() && filteredRows().length">
      <article class="type-def-card" *ngFor="let t of filteredRows()">
        <header class="type-def-head">
          <div>
            <code class="type-code">{{ t.code }}</code>
            <h3>{{ t.name }}</h3>
          </div>
          <app-status-badge [statusCd]="t.statusCd">{{ t.statusCd }}</app-status-badge>
        </header>
        <p class="type-def-meta">{{ t.fields.length }} dynamic field(s)</p>
        <ul class="field-chip-list">
          <li *ngFor="let f of t.fields" class="field-chip">
            {{ f.label }}
            <span class="chip-type">{{ f.field_type }}</span>
            <span class="chip-req" *ngIf="f.is_required">required</span>
          </li>
        </ul>
        <footer class="type-def-actions" *ngIf="session.canAccessConfig()">
          <button type="button" class="btn secondary btn-compact" (click)="openEditType(t)">Edit template</button>
          <button type="button" class="btn secondary btn-compact" *ngIf="t.statusCd === 'active'" (click)="deactivateType(t)">
            Deactivate
          </button>
        </footer>
      </article>
    </div>
  </section>
</div>

<div class="loc-form-overlay" *ngIf="typeModalOpen()" (click)="closeTypeModal()">
  <div
    class="loc-form-sheet loc-form-sheet--wide"
    role="dialog"
    aria-modal="true"
    aria-labelledby="typeFormTitle"
    (click)="$event.stopPropagation()"
  >
    <header class="loc-form-sheet-head">
      <div>
        <p class="loc-form-sheet-kicker">Location type template</p>
        <h3 id="typeFormTitle">{{ editingTypeId() ? 'Edit type' : 'Create type' }}</h3>
      </div>
      <button type="button" class="loc-form-close" (click)="closeTypeModal()" aria-label="Close">×</button>
    </header>

    <div class="form-grid">
      <label>Code <input [(ngModel)]="typeForm.code" [readonly]="!!editingTypeId()" placeholder="e.g. WARD" /></label>
      <label>Display name <input [(ngModel)]="typeForm.name" placeholder="Ward" /></label>
    </div>

    <h4 class="builder-title">Field builder</h4>
    <p class="muted builder-lead">These fields appear on every location instance of this type.</p>

    <div class="builder-table">
      <div class="builder-head">
        <span>Key</span><span>Label</span><span>Type</span><span>Req.</span><span></span>
      </div>
      <div class="builder-row" *ngFor="let f of typeForm.fields; let i = index">
        <input [(ngModel)]="f.key" placeholder="key" />
        <input [(ngModel)]="f.label" placeholder="Label" />
        <select [(ngModel)]="f.field_type">
          <option value="text">text</option>
          <option value="number">number</option>
          <option value="date">date</option>
        </select>
        <label class="req-check"><input type="checkbox" [(ngModel)]="f.is_required" /></label>
        <button type="button" class="btn secondary btn-compact" (click)="removeTypeFieldRow(i)">Remove</button>
      </div>
    </div>
    <button type="button" class="btn secondary btn-compact" (click)="addTypeFieldRow()">
      <lucide-icon name="plus" [size]="14" /> Add field
    </button>

    <footer class="loc-form-actions">
      <button type="button" class="btn primary" (click)="saveType()" [disabled]="saving()">
        {{ saving() ? 'Saving…' : 'Save type' }}
      </button>
      <button type="button" class="btn secondary" (click)="closeTypeModal()" [disabled]="saving()">Cancel</button>
    </footer>
  </div>
</div>
